var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isK5)?_c('k5-import'):_c('georg-import')}
var staticRenderFns = []

export { render, staticRenderFns }